
import { defineComponent } from 'vue';
import BaseLayout from '@/sandbox/slot/BaseLayout.vue'
import NavigationLink from '@/sandbox/slot/NavigationLink.vue'
import ScopeSlot from '@/sandbox/slot/ScopeSlot.vue'

export default defineComponent({
  components: {
    BaseLayout,
    NavigationLink,
    ScopeSlot
  },
  data () {
    return {
      msg: 'new msg !!'
    }
  }
})
